import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TMHBanner from "../../components/TMHBanner/TMHBanner";
import TMHFormWrapper from "../../components/TMHForm/TMHFormWrapper";
import TMHFormBase from "../../components/TMHForm/TMHFormBase";
import TMHFormInput from "../../components/TMHForm/TMHFormInput";
import Separator from "../../components/Separator/Separator";
import TMHLoader from "../../components/TMHLoader/TMHLoader";
import "./SignUpPage.css";
import validator from 'validator';
import config from "../../config.json"
import useAuth from "../../core/Authentication/useAuth"
import { useTitle } from 'react-use'
import ReactGA from "react-ga4"

export default function SignUpPage() {
    useTitle("SignUp - The Movie House TV")
    useEffect(() => {
        ReactGA.send("pageview")
    })

    const auth = useAuth()
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false);
    const [emailAddress, setEmailAddress] = useState("");
    const [password, setPassword] = useState("");
    const [errorText, setErrorText] = useState("")

    async function handleSubmit(event) {
        event.preventDefault()
        if (!validator.isEmail(emailAddress)){
            setErrorText("Invalid email address!")
            return
        }

        if (password === "") {
            setErrorText("Password cannot be empty!")
            return
        }

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Cache-Control", "no-cache");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({
                "username": emailAddress,
                "password": password
            }),
        };

        setErrorText("")
        setIsLoading(true)
        fetch(config.baseUrl + "register", requestOptions)
            .then((response) => {
            return new Promise((resolve) => response.json()
              .then((json) => resolve({
                status: response.status,
                ok: response.ok,
                json,
              })))
            }).then(
                (result) => {
                    let json = result.json
                    if (result.ok) {
                        auth.login({
                            pin: json.pin,
                            username: json.username,
                            user_id: json.user_id,
                            token: json.token
                        })
                        navigate("/congratulations");
                    }
                    else {
                        setErrorText(json.message)
                        setIsLoading(false)
                    }
                },
                (error) => {
                    console.error(error)
                    setErrorText(error.toString())
                    setIsLoading(false)
                }
            )
    }

    return (
        <TMHBanner isLogged={false}>
            <TMHFormWrapper>
                <TMHFormBase onSubmit={handleSubmit} method="POST">
                    <div className="signup-page-warring-text">New release movies are for members only!</div>
                    <Separator />
                    <div className="signup-page-title">
                        <span>Create your free account on </span>
                        <span className="red-color">The Movie House </span>
                        <span>today</span>
                    </div>
                    <div className="signup-page-credit-text">No credit card needed or asked for, <span className="text-underline">ever!</span></div>
                    <div className="red-color">{errorText}</div>
                    <TMHFormInput
                        type="text"
                        placeholder="Email"
                        value={emailAddress}
                        onChange={({ target }) => setEmailAddress(target.value)}
                    />
                    <TMHFormInput
                        type="password"
                        placeholder="Password"
                        autoComplete="off"
                        value={password}
                        onChange={({ target }) => setPassword(target.value)}
                    />
                    <div className="signup-page-ensure-text">Ensure your details are correct as this is where we will send your code for your new release movie access</div>
                    <button type="submit" className="signup-page-join-now-button">
                        <div className="signup-page-join-now-text">Join now &#38; start watching</div>
                    </button>
                </TMHFormBase>
                {isLoading && <TMHLoader />}
            </TMHFormWrapper>
        </TMHBanner>
    )
}